const currencyFormatter = value => {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  const currency = formatter.format(value).replace('$', '');

  if (currency === 'NaN') return value;

  return currency;
};

export { currencyFormatter };
